import { styled } from "@linaria/react";
export const NumberOverlayEditorStyle = /*#__PURE__*/styled('div')({
  name: "NumberOverlayEditorStyle",
  class: "gdg-n15fjm3e",
  propsAsIs: false
});

